import { useEffect, useState } from "react"
import ReactDOM from "react-dom";

import { useSelector } from "react-redux"
import Backdrop from "../../common/modal/Backdrop";
import Modal from "../../common/Modal";
import ModalInnerWrapper from "../../common/ModalInnerWrapper";
import PannelBody from "../../fragments/PannelBody";
import Button from "../../common/Button";


import classes from './DetailsAlerts.module.css'
import { miscellaneous } from "../../../lib/misc"

export default function DetailsAlerts() {

    const activeCase = useSelector(state => state.case.activeCase)

    const [existingAlerts, setExistingAlerts] = useState()

    useEffect(() => {
        if (activeCase && activeCase.case_alerts && activeCase.case_alerts.length ) {
            let unresolved = activeCase.case_alerts.filter(item => !item.resolved)
            const caseAlerts = miscellaneous.getCaseAlertsLocalStorage(activeCase?.case?.id)
            if (unresolved && unresolved.length && !caseAlerts) {                
                miscellaneous.setCaseAlertsLocalStorage(activeCase?.case?.id)
                setExistingAlerts(unresolved)
            } else {
                setExistingAlerts(null)
            }
        }
    }, [])

    function closeModalHandler() {
        setExistingAlerts(null)
    }
    return <>
        {existingAlerts && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Case Alerts'}>
                        <PannelBody>
                            <div className={classes.alerts_wrapper}>
                                <ul className={classes.alert_list}>
                                    {existingAlerts && existingAlerts.map(item => (
                                        <li key={item.id} dangerouslySetInnerHTML={{__html: item.note}}></li>
                                    ))}
                                </ul>
                            </div>
                            
                        </PannelBody>
                        <PannelBody>
                            <Button click={closeModalHandler}>Close</Button>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}